import React, { useContext } from "react";
import { DesktopEarnBannerConnectorProps } from "./container";
import { Typography } from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import "./styles.scss";
import { Icon, IconName, BannerSeverity, NotificationBanner, SanitizedHtml } from "halifax";
import { CustomerAccountRole } from "redmond";
import { getCurrentCorpAccount, isCorpTenant } from "@capone/common";
import { config } from "../../../../api/config";
import { ClientContext } from "../../../../App";
import * as textConstants from "./textConstants";

export interface DesktopEarnBannerProps
  extends DesktopEarnBannerConnectorProps,
    RouteComponentProps {
  variant?: "default" | "lifestyle-collection";
}

export const DesktopEarnBanner = (props: DesktopEarnBannerProps) => {
  const { variant, largestEarnAccount, rewardsAccounts } = props;

  const { sessionInfo } = useContext(ClientContext);

  const accountToUse = isCorpTenant(config.TENANT)
    ? getCurrentCorpAccount(rewardsAccounts, sessionInfo) || largestEarnAccount
    : largestEarnAccount;

  if (!accountToUse?.earn) {
    return null;
  }

  const currency = accountToUse.rewardsBalance?.currencyDescription ||
    accountToUse.rewardsBalance?.currency;

  return (
    <NotificationBanner
      className="pc-earn-banner"
      content={
        <SanitizedHtml
          as={Typography}
          className="pc-earn-banner-text"
          html={
            variant === "lifestyle-collection"
              ? textConstants.getLCEarnBannerText(
                  accountToUse.earn.hotelsMultiplier,
                  accountToUse.customerAccountRole ===
                    CustomerAccountRole.Primary,
                  currency
                )
              : textConstants.getPCEarnBannerText(
                  accountToUse.earn.hotelsMultiplier,
                  currency
                )
          }
        />
      }
      severity={BannerSeverity.INFO}
      icon={<Icon className="banner-icon" name={IconName.StarOutline} />}
    />
  );
};
